import React from 'react';
import classnames from 'classnames';

import { Text, TextType } from 'ui-components/components/text';
import { noop } from 'ui-components/default-props/noop';

import { CarrierServiceTag } from './carrier-service-tag';
import messages from './messages';
import style from './style.module.less';

const isDomesticOnlyService = (service) => !(service?.isInternational || service?.features?.supportsInternationalShipping);

/** @typedef {import('../../prop-types/shipping-strategy-carrier-service').ShippingStrategyCarrierService} ShippingStrategyCarrierService */
/** @typedef {import('../../prop-types/rate-shopper-carrier-service').RateShopperCarrierService} RateShopperCarrierService */

/**
 *
 * @param {object} props
 * @param {Array<ShippingStrategyCarrierService|RateShopperCarrierService> | undefined} [props.carrierServices] `[]` by default
 * @param {string} [props.className] `''` by default
 * @param {() => void} [props.onCarrierServiceRemoved] `noop` by default
 * @param {boolean} [props.shouldAllowRemoval] `false` by default
 * @param {boolean} [props.shouldShowPackageAndConfirmation] `false` by default
 * @param {boolean} [props.shouldSeparateInternationalServices] `false` by default
 * @returns {React.JSX.Element}
 */
export const CarrierServiceTagBank = ({
  carrierServices = [],
  className = '',
  onCarrierServiceRemoved = noop,
  shouldAllowRemoval = false,
  shouldShowPackageAndConfirmation = false,
  shouldSeparateInternationalServices = false,
}) => {
  if (shouldSeparateInternationalServices) {
    const domesticOnlyServices = carrierServices.filter(isDomesticOnlyService);
    const internationalServices = carrierServices.filter((service) => !isDomesticOnlyService(service));
    return (
      <>
        <div className={classnames(style['carrier-tag-bank'], className)}>
          {domesticOnlyServices.map((carrierService, index) => (
            <CarrierServiceTag
              key={`${carrierService?.serviceId}-${index}`}
              carrierService={carrierService}
              onCarrierServiceRemoved={onCarrierServiceRemoved}
              shouldAllowRemoval={shouldAllowRemoval}
              shouldShowPackageAndConfirmation={shouldShowPackageAndConfirmation}
            />
          ))}
        </div>
        {internationalServices?.length ? (
          <>
            <Text
              className={classnames(style['international-services-header'], { [style['being-edited']]: shouldAllowRemoval })}
              textType={TextType.H4}
              value={messages.tagBankInternationalServices}
            />
            <div className={classnames(style['carrier-tag-bank'], className)}>
              {internationalServices.map((carrierService, index) => (
                <CarrierServiceTag
                  key={`${carrierService?.serviceId}-${index}`}
                  carrierService={carrierService}
                  onCarrierServiceRemoved={onCarrierServiceRemoved}
                  shouldAllowRemoval={shouldAllowRemoval}
                  shouldShowPackageAndConfirmation={shouldShowPackageAndConfirmation}
                />
              ))}
            </div>
          </>
        ) : null}
      </>
    );
  }

  return (
    <div className={classnames(style['carrier-tag-bank'], className)}>
      {carrierServices.map((carrierService, index) => (
        <CarrierServiceTag
          key={`${carrierService?.serviceId}-${index}`}
          carrierService={carrierService}
          onCarrierServiceRemoved={onCarrierServiceRemoved}
          shouldAllowRemoval={shouldAllowRemoval}
          shouldShowPackageAndConfirmation={shouldShowPackageAndConfirmation}
        />
      ))}
    </div>
  );
};
